import type { CustomInterstateValidationRule } from '@makemydeal/dr-dash-components';
import { customInterstateValidationRules as rules } from '@makemydeal/dr-dash-components';
import type { ManualProduct } from '@makemydeal/dr-shared-types';

export const PRODUCT_NAME_MAX_LENGTH = 256;
export const PRODUCT_CODE_MAX_LENGTH = 128;
export const PRODUCT_PRICE_MAX_VALUE = 1000000;
export const PRODUCT_NAME_REQUIRED_MESSAGE = 'Name is required';

/** Trims before testing, matching the save-flow rule, so a whitespace-only value is not accepted. */
const getTrimmedRequiredValidationRule = (errorMessage: string): CustomInterstateValidationRule => {
    const required = rules.getRequiredValidationRule(errorMessage);
    return (value) => required(typeof value === 'string' ? value.trim() : value);
};

export const getProductNameValidationRules = (isOptionalDeskingMode: boolean) => {
    const maxLength = rules.getMaxLengthValidationRule(
        PRODUCT_NAME_MAX_LENGTH,
        `Value should be less than ${PRODUCT_NAME_MAX_LENGTH} characters`
    );

    if (isOptionalDeskingMode) {
        return [maxLength];
    }

    const required = getTrimmedRequiredValidationRule(PRODUCT_NAME_REQUIRED_MESSAGE);
    return [required, maxLength];
};

export const getProductTypeValidationRules = () => {
    const required = rules.getRequiredValidationRule('Type is required');

    return [required];
};

export const getProductCodeValidationRules = () => {
    const maxLength = rules.getMaxLengthValidationRule(
        PRODUCT_CODE_MAX_LENGTH,
        `Value should be less than ${PRODUCT_CODE_MAX_LENGTH} characters`
    );

    return [maxLength];
};

export const getProductPriceValidationRules = () => {
    const maxLength = rules.getMaxValueValidationRule(PRODUCT_PRICE_MAX_VALUE, `Value should be less than 1 million`, false);

    return [maxLength];
};

export const getValidationMap = (
    isOptionalDeskingMode: boolean
): Partial<Record<keyof ManualProduct, CustomInterstateValidationRule[]>> => ({
    productName: getProductNameValidationRules(isOptionalDeskingMode),
    productCategoryCode: getProductTypeValidationRules(),
    productCode: getProductCodeValidationRules(),
    productPrice: getProductPriceValidationRules(),
    productCost: getProductPriceValidationRules()
});
